<style scoped>
</style>

<template>
	<div>
		<v-alert 
			v-for="(alert, index) in alerts" 
			:key="alert.id"
			:type="alert.type"
			:class="{ 'mt-2': index > 1 }"
			dismissible
			border="left"
			colored-border
			@input = "alerts.splice(index, 1)"
		>
			{{ alert.message }}
		</v-alert>
	</div>
</template>

<script>
export default {
	data() {
		return {
			last_id: 0,
			alerts: []
		}
	},
	methods: {
		add_alert(message, type) {
			this.last_id = this.last_id + 1;
			this.alerts.push({
				id: this.last_id,
				type: type,
				message: message
			})
		},
		add_error(errormsg) {
			this.add_alert(errormsg, 'error')
		},
		add_warning(warningmsg) {
			this.add_alert(warningmsg, 'warning')
		},
		add_info(infomsg) {
			this.add_alert(infomsg, 'info')
		},
	}
}	
</script>
